import * as React from "react";
import { cn } from "@/lib/utils";

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "input-control flex h-11 w-full rounded-md border border-border-standard bg-surface-container-lowest px-3.5 py-2.5 text-sm text-text-primary shadow-none transition-[border-color,box-shadow,background-color] duration-standard ease-standard file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-text-disabled focus-visible:border-secondary focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-secondary-fixed-dim disabled:cursor-not-allowed disabled:opacity-50",
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = "Input";

export { Input };
